'use strict';
import Base  from './ResetPasswordBase';
import Render  from './ResetPasswordRender';

export default class ResetPassword extends Base {
    render() {
        return Render.call(this, this.props, this.state);
    }
}
